import React from 'react';
import { Box, Typography } from '@mui/material';
import WorkOutlineIcon from '@mui/icons-material/WorkOutline';

import { formatGroupName, GroupedCandidates } from '../grouping';

export const CandidateGroupHeader: React.FC<{ group: GroupedCandidates }> = ({
  group,
}) =>
  group.name ? (
    <Box display="flex" alignItems="center" gap={1} minWidth={0}>
      <WorkOutlineIcon
        sx={{ fontSize: 16, color: 'text.secondary', flexShrink: 0 }}
      />
      <Typography component="span" variant="body2" fontWeight={600} noWrap>
        {formatGroupName(group.name)}
      </Typography>
      <Typography component="span" variant="body2" color="text.secondary">
        {group.candidates.length}
      </Typography>
    </Box>
  ) : null;
